export enum InputType {
    TEXT = 'text',
    COLOR = 'color',
    EMAIL = 'email',
    NUMBER = 'number',
    PASSWORD = 'password',
    SEARCH = 'search',
    TEL = 'tel',
    URL = 'url'
}